export interface SavingModel {
  id: number;
  userId?: number;
  name: string;
  description: string;
  startingAmount: number;
  goalAmount: number;
  goalDate: string;

  totalDepositsAmount: number;
  totalWithdrawalAmount: number;
  monthsLeft: number;
}
